import React, { useCallback, useState } from "react";
import CtoSelect from '../../../../components/CtoSelect'
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, TextField } from "@mui/material";
import { useFormError } from "../../../../components/Datatable/FormErrorProvider";
import api from "../../../../services/api";
import { useNotify } from "../../../../components/Datatable/NotifyProvider";
import FreeOnuSelect from "../FreeOnuSelectDetail";
import { SearchRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import ProfileSelect from "../../../../components/ProfileSelect";
import FreeOnuSelectSimple from "../FreeOnuSelectSimple";
import CustomTextField from "../../../../components/CustomTextField";
import ProvisioningProgressModal from "../../../../components/ProvisioningProgressModal";
import { duration } from "moment";


function genTaskId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "").slice(0, 8);
  return Math.random().toString(16).slice(2, 10);
}


export default function ProvSimple() {
  const error = useFormError()
  const [taskId, setTaskId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [result, setResult] = useState(null)
  const [searchOnu, setSearchOnu] = useState(false)


  const [waitOlt, setWaitOlt] = useState(true)


  const fetchProv = () => {
    error.setErrors([])
    const tid = genTaskId()
    setTaskId(tid)
    setResult(null)
    setModalOpen(true)
    const snap = { ...state }
    api.post(`provisioning/olt/prov/simple/?task_id=${tid}`, { ...state, roteada: state.roteada == 2 })
      .then(res => {
        if (res.data.error) {
          setResult({ ok: false, message: res.data.error })
          return
        }
        if (res.data.errors) {
          setModalOpen(false)
          error.setErrors(res.data.errors)
          return
        }

        setResult({
          ok: true,
          message: "ONU provisionada com sucesso",
          info: [
            { label: "SN", value: snap.sn },
            { label: "CTO", value: snap.cto },
            { label: "Perfil", value: snap.profile },
            { label: "Modo", value: snap.roteada == 2 ? "Roteada" : "Bridge" },
            { label: "Descrição", value: snap.description },
          ],
        })
        setState({
          sn: null,
          profile: null,
          description: "",
          roteada: 1,

        })
      }

      )
      .catch(e => {
        setResult({ ok: false, message: "Falha: " + (e?.message || e) })
      })
  }
  const [state, setState] = useState({
    sn: "",
    vlan: "",
    cto: "",
    line: null,
    srv: null,
    description: "",
    roteada: 1,
    olt: null,
    board: "",
    port: ""
  })
  const notify = useNotify()


  const handleState = useCallback((event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  }, [state])


  return (

  
      <Box flexDirection={"column"} gap={1}  display={"flex"} 
      sx={{
        width: {xs: "auto", sm:"auto", md: 400}
      }}
      >

        <Box display={"flex"} gap={1} flexDirection={"row"}  >

          <CtoSelect
            fullWidth
            size="small"
            value={state.cto}
            handler={(e) => { setState({ ...state, cto: e }); setWaitOlt(true) }}
            admin={false}
          
          />
          
          <Button

            variant="contained"
            color="primary"
            size="small"
            onClick={() => { setSearchOnu(true); setWaitOlt(false) }}
            disabled={!state.cto}
          >
            <SearchRounded />
          </Button>
          
          
        </Box>

        <FreeOnuSelectSimple
          waitOlt={waitOlt}
          cto={state.cto}
          fullWidth
          submit={searchOnu}
          handlerSn={(sn) => setState(prev => ({ ...prev, sn }))}
          handlerSubmit={() => setSearchOnu(false)}

        />
        <ProfileSelect
          fullWidth
          disabled={waitOlt}
          handler={(profile) => setState(prev => ({ ...prev, profile }))}
          size="small"

        />
        <FormControl fullWidth size="small" >
          <InputLabel id="mode-prov-select-label">Modo</InputLabel>
          <Select
            disabled={waitOlt}
            inputProps={{ size: "small" }}
            labelId="mode-prov-select-label"
            id="mode-prov-select-1"
            value={state?.roteada}
            label="Modo"
            onChange={e => setState({ ...state, roteada: e.target.value })}
          >
            <MenuItem value={1}>Brigde</MenuItem>
            <MenuItem value={2}>Roteada</MenuItem>

          </Select>
        </FormControl>


        <CustomTextField
          disabled={waitOlt}
          size="small"
          error={error.verify('description')}
          helperText={error.msgError('description')}
          label='Descrição'
          value={state.description}
          name={'description'}
          onChange={handleState}
          type="text"
          fullWidth
        />




        <Button variant="contained" disabled={waitOlt}
        fullWidth

          onClick={fetchProv}>{"Provisionar"}</Button>

        <ProvisioningProgressModal
          open={modalOpen}
          taskId={taskId}
          mode="user"
          streamPath="/provisioning/stream"
          result={result}
          onClose={() => { setModalOpen(false); setResult(null) }}
        />

      </Box >
  )
}